<script setup lang="ts">
const props = withDefaults(defineProps<{
  w?: string
  options?: {
    relative: boolean
    fullHeight: boolean
  }
}>(), {
  w: '',
  options: () => {
    return {
      relative: true,
      fullHeight: false,
    }
  },
})

const $attrs = useAttrs()

const filteredAttrs = computed(() => {
  const myAttrs = { ...$attrs }
  delete myAttrs.class

  return myAttrs
})
</script>

<template>
  <div class="m-content">
    <Wrap
      v-bind="filteredAttrs" :class="[{
        'h-full': options.fullHeight,
      }, w]"
    >
      <slot />
    </Wrap>
  </div>
</template>

<style lang="scss" scoped>
.m-content {
  /* First level wrap */
  :deep(> .m-wrap) {
  }

  /* All Wraps */
  :deep(.m-wrap) {
  }
}
</style>
